export const consentContent = {
  title: "GDS Axon – Service Manager",
  subtitle: "User Consent & Acknowledgement",
  prompt: "Please review and confirm the following before proceeding:",
  bullets: [
    "I confirm that I have all required rights, permissions, client consents, and internal approvals to use this tool.",
    "I confirm that use of this tool is permitted for my engagement, jurisdiction, and intended use case.",
    "I will not upload or enter restricted data, including sensitive personal data, government identifiers, or confidential information that violates legal or contractual obligations.",
    "I will not use this tool for restricted engagements where data usage, transfer, or processing is prohibited.",
    "I will use this tool strictly within the approved scope and purpose.",
    "I will ensure all data entered complies with EY Data Protection and Information Security requirements.",
    "I understand that my activity may be monitored for security, compliance, and audit purposes.",
    "I will review and validate all outputs before using them for any business purpose.",
    "I will seek guidance from the engagement team or relevant Risk/Legal/Privacy stakeholders if unsure about permitted use.",
  ],
  declarationHeading: "Declaration",
  declarationText:
    'By selecting "Agree", I confirm that I have read, understood, and will comply with the above conditions and applicable EY policies.',
};
